import styled, { css } from 'styled-components';

export const Grid = styled.div`
  ${({ columns }) => css`
    display: grid;
    grid-template-columns: repeat(${columns}, 1fr);
    gap: 1.5rem;
  `}
`;
